export default __webpack_public_path__ + "static/media/logo.3bb00d02.gif";